export function makeElement(view) {
    return (new DOMParser()).parseFromString(view, "text/html").body.querySelector('*');
}
//# sourceMappingURL=componentHelpers.js.map